import { render, staticRenderFns } from "./productSpecs.vue?vue&type=template&id=16d2c066&"
import script from "./productSpecs.vue?vue&type=script&lang=js&"
export * from "./productSpecs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports